import { CheckCircle } from "@mui/icons-material";
import { Box, Container, Divider, Paper, Typography } from "@mui/material";
import moment from "moment";

export default function ConfirmacaoEnvio({
    nomeFornecedor,
    dataCotacao
}: ConfirmacaoEnvioProps) {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: 'grey.100', py: 8 }}>
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ p: 6, textAlign: 'center' }}>
                <CheckCircle
                    sx={{
                        fontSize: 80,
                        color: 'success.main',
                        mb: 3
                    }}
                />

                <Typography variant="h4" component="h1" color="success.main" gutterBottom>
                    Cotação Enviada com Sucesso!
                </Typography>

                <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
                    Sua cotação foi recebida e está sendo processada pela cooperativa.
                </Typography>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                        <strong>Próximos passos:</strong>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • A cooperativa analisará sua cotação
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • Você será contactado em caso de dúvidas
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        • O resultado será comunicado em breve
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ mt: 4, p: 3, bgcolor: 'grey.50', borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        <strong>Data de Envio:</strong> {moment(dataCotacao).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        <strong>Fornecedor:</strong> {nomeFornecedor}
                    </Typography>
                </Box>
            </Paper>
            </Container>
        </Box>
    )
}

interface ConfirmacaoEnvioProps{
    nomeFornecedor: string
    dataCotacao: string
}